/** Full-screen card with the Transect logo and the ASTIA credit, for the pages outside the app shell. */
import type { ReactNode } from 'react';
import styles from './Auth.module.css';

export function AuthLayout({ children }: { children: ReactNode }) {
  return (
    <div className={styles.page}>
      <main className={styles.card}>
        <div className={styles.logoPlate}>
          <img src="/brand/transect-logo.png" alt="Transect – archeologisch onderzoek en advies" width={180} height={60} className={styles.logo} />
        </div>
        {children}
      </main>

      <footer className={styles.footer}>
        <span>Ontwikkeld door</span>
        <span className={styles.astiaPlate}>
          <img src="/brand/astia-logo.png" alt="ASTIA" width={72} height={16} className={styles.astia} />
        </span>
        <span>voor Transect</span>
      </footer>
    </div>
  );
}
